import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import MUIButton from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import useStyles from './useStyles';

const propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}),
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  variant: PropTypes.oneOf(['text', 'outlined', 'contained', 'round']),
  color: PropTypes.oneOf(['inherit', 'primary', 'secondary', 'default', 'white', 'gray']),
  noHover: PropTypes.bool,
};

const defaultProps = {
  className: null,
  classes: null,
  loading: false,
  disabled: false,
  children: null,
  noHover: false,
};

const Button = forwardRef(
  ({ className, classes, loading, disabled, children, variant, color, noHover, ...props }, ref) => {
    const styles = useStyles({ classes });
    const isRound = variant === 'round';
    const preparedVariant = isRound ? 'outlined' : variant;
    const preparedColor = color === 'white' ? 'inherit' : color;
    return (
      <MUIButton
        {...props}
        variant={preparedVariant}
        color={preparedColor}
        ref={ref}
        className={cx(
          styles.root,
          { [styles.loading]: loading },
          { [styles.round]: isRound },
          { [styles.whiteColor]: color === 'white' },
          { [styles.grayColor]: color === 'gray' },
          { [styles.noHover]: noHover },
          className
        )}
        disabled={disabled || loading}
      >
        <span className={styles.label}>{children}</span>

        {loading && (
          <CircularProgress
            className={styles.spinner}
            size={24}
          />
        )}
      </MUIButton>
    );
  }
);

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

export default Button;
